<template>
    <div class='goods-card' @click="handleGoodsCard">
        <div class="goods-card-main">
            <img class="goods-pic" :src="item.pict_url" v-lazy="item.pict_url"  alt="">
            <div class="goods-info">
                <div class="goods-title" :class="[{'van-multi-ellipsis--l2': !isGYApp}, {'van-ellipsis': isGYApp}]"><img class="platform-icon" :src="item.classtype | classTypeImg" alt="">{{item.title}}</div>
                <div>
                    <div class="coupon" v-if="item.couponmoney">{{ item.couponmoney }}元券</div>
                    <div class="commission-wrap" v-if="isGYApp">
                        <div class="commission-pre">返{{ item.gy_commission }}元+补{{ item.gy_subsidy_info.self_money }}元</div>
                        <div class="commission">赚{{totalCommission()}}元</div>
                    </div>
                    <div class="price-sale-wrap">
                        <div class="price-wrap">
                            <div class="now-price">￥<span>{{item.itemendprice|pricePartFilter}}</span>{{item.itemendprice|pricePartFilter(2)}}</div>
                            <div class="orig-price">￥{{item.zk_final_price}}</div>
                        </div>
                        <div class="sale" v-if="item.volume">{{item.volume | saleFilter}}人购买</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn-wrap" v-if="isGYApp">
            <div class="btn share-btn" @click.stop="handleShareLink">分享推广链接</div>
            <div class="btn buy-btn" @click.stop="handleBuy">立即购买</div>
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex'
import Vue from 'vue';
import { Lazyload } from 'vant';
import {getUrlParam, goodsJump, linkJump, operation} from "@/common/utils";
import {goodsBuyUrl} from "@/common/api";

Vue.use(Lazyload, {
    lazyComponent: true,
    preLoad: 1.3,
    error: "http://img.bc.haodanku.com/haodanku/1595237918",
    loading: "http://img.bc.fqapps.com/fudai13cae4ae6ef16739ed3b100a2ec39e97.gif",
    attempt: 1
});
export default {
    name: 'GoodsCard',
    components: {},
    computed: {
        ...mapState({
            userInfo: (state) => {
                let obj = {
                    userId: state.common.userInfo.uid || getUrlParam('shareUid'),
                    userType: state.common.userInfo.utype || getUrlParam('shareUtype'),
                }
                return obj
            }
        }),
    },
    props: {
        item: {
            type: Object,
            default: () => {
                return {}
             }
        },
        pid: {
            type: String,
            default: ''
        },
        isGYApp: Boolean
    },
    data() {
        return {
            goodsBuyInfo: {}
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    methods: {
        totalCommission() {
            return operation.add(this.item.gy_commission, this.item.gy_subsidy_info.self_money)
        },
        handleShareLink() {
            this.$uweb.trackEvent("activity2022", `PDDYJFB:(${this.item.itemid})商品分享按钮点击量`, this.$GY_platform.currentPlatform)
            goodsJump({
                type: 16,
                appurl: `${this.item.itemid}￥￥￥${this.item.classtype}￥￥￥0￥￥￥0`
            })
        },
        handleBuy() {
            this.$uweb.trackEvent("activity2022", `PDDYJFB:(${this.item.itemid})商品立即购买按钮点击量`, this.$GY_platform.currentPlatform)
            if (this.goodsBuyInfo.pddSelfBuyUrl) {
                this.goBuy()
            } else {
                this.getGoodsBuyUrl()
            }
        },
        getGoodsBuyUrl() {
            const req = {
                ...this.userInfo,
                classType: this.item.classtype,
                pid: this.pid,
                goodsId: this.item.itemid,
                gylmExtra: this.item.gylmExtra,
                zsDuoId: this.item.zs_duo_id
            }
            goodsBuyUrl(req, true).then(res => {
                if (res.data.code == 200 && res.data.data) {
                    this.goodsBuyInfo = res.data.data
                    this.goBuy()
                }
            })
        },
        goBuy() {
            if (this.isGYApp) {
                let appurl = this.goodsBuyInfo.pddSelfBuyUrl
                if (this.$GY_platform.isGYAndroidApp) {
                    appurl = `com.xunmeng.pinduoduo￥￥￥${this.goodsBuyInfo.pddSelfBuyUrl}￥￥￥${this.goodsBuyInfo.shortUrl}￥￥￥请下载拼多多App￥￥￥0`
                }
                let obj = {
                    type: 48,
                    appurl: appurl,
                    appPackage: 'com.xunmeng.pinduoduo',
                    originUrl: this.goodsBuyInfo.pddSelfBuyUrl,
                    otherCode: 'code-提示-请下载拼多多App'
                }
                goodsJump(obj)
            } else {
                window.location.href = this.goodsBuyInfo.shortUrl
            }
        },
        handleGoodsCard() {
            this.$uweb.trackEvent("activity2022", `PDDYJFB:(${this.item.itemid})商品详情点击量`, this.$GY_platform.currentPlatform)
            if (this.isGYApp) {
                linkJump({classtype: this.item.classtype, goodsId: this.item.itemid}, this.item)
            } else {
                if (this.goodsBuyInfo.shortUrl) {
                    this.goBuy()
                } else {
                    this.getGoodsBuyUrl()
                }
            }
        }
    }
}
</script>

<style scoped lang="less">
.goods-card {
    margin: 0 auto 16px;
    padding: 24px;
    width: 702px;
    min-height: 248px;
    background: #FFFFFF;
    border-radius: 24px;

    .goods-card-main {
        display: flex;
        justify-content: space-between;

        .goods-pic {
            width: 200px;
            height: 200px;
            border-radius: 16px;
        }

        .goods-info {
            width: 430px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .goods-title {
                width: 430px;
                line-height: 42px;
                font-size: 30px;
                color: #1A1A1A;

                .platform-icon {
                    margin-top: 7px;
                    margin-right: 10px;
                    width: 28px;
                    height: 28px;
                    vertical-align: top;
                }

            }

            .coupon {
                padding: 0 10px;
                width: fit-content;
                height: 32px;
                font-size: 20px;
                color: #FD3240;
                border-radius: 10px;
                border: 1px solid rgba(253, 50, 64, .3);
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .commission-wrap {
                margin-top: 10px;
                width: fit-content;
                display: flex;
                align-items: center;

                .commission-pre {
                    height: 32px;
                    padding: 0 10px;
                    background: #FFFFFF;
                    color: #FD3240;
                    font-size: 20px;
                    border-radius: 10px 0 0 10px;
                    border: 1px solid rgba(253,50,64,0.3);
                    border-right: none;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .commission {
                    height: 32px;
                    padding: 0 10px;
                    background: rgba(253,50,64,0.1);
                    color: #FD3240;
                    font-size: 20px;
                    border-radius: 0 10px 10px 0;
                    border: 1px solid rgba(253,50,64,0.3);
                    border-left: none;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }

            .price-sale-wrap {
                margin-top: 4px;
                height: 50px;
                display: flex;
                justify-content: space-between;
                align-items: baseline;

                .price-wrap {
                    display: flex;
                    align-items: baseline;

                    .now-price {
                        margin-right: 8px;
                        color: #FD3240;
                        font-size: 24px;
                        font-weight: bold;
                        span {
                            font-size: 36px;
                        }
                    }
                    .orig-price {
                        color: #B2B2B2;
                        font-size: 24px;
                        text-decoration: line-through;
                    }
                }

                .sale {
                    color: #B2B2B2;
                    font-size: 24px;
                }
            }
        }
    }

    .btn-wrap {
        margin-top: 24px;
        display: flex;
        justify-content: space-between;

        .btn {
            width: 316px;
            height: 74px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 30px;
            border-radius: 130px;

            &.share-btn {
                border: 1px solid #FD3240;
                color: #FD3240;
            }

            &.buy-btn {
                background: #FD3240;
                color: #FFFFFF;
            }
        }

    }
}
</style>
